import React from 'react';

import { HelpTip, Typography } from '@occc/ui-design-system';

export const FixedDateRangeAudienceWarning: React.FC = () => (
  <HelpTip title='Fixed Date Range purchase based audiences'>
    <Typography variant='body2' color='textSecondary'>
      Fixed Date Range purchase based audiences are not available for use until one day after their
      creation.
    </Typography>
  </HelpTip>
);
